/**
 *
 * Asynchronously loads the component for Locations Page
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Locations = lazyLoad(
  () => import('./index'),
  module => module.LocationsPage,
);
